<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    :class="['qb-sidebar', 'items-no-padding', size]"
    spacer
    v-model="isSidebarActive"
  >
    <div :id="`loading-${name}`" class="vs-con-loading__container">
      <div
        class="pt-4 px-4 flex items-center justify-between"
        :style="{
          'background-color': bgColor,
          color: textColor,
        }"
      >
        <span class="sidebar-title f-bold">{{ title }}</span>
        <feather-icon
          icon="XIcon"
          @click.stop="close"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vue-perfect-scrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
      >
        <div
          :style="{
            'background-color': bgColor,
            color: textColor,
          }"
          class="pb-4"
        >
          <slot name="header"></slot>
        </div>
        <div class="pt-4">
          <slot></slot>
        </div>
        <div class="items-center pt-2 mb-2">
          <slot name="footer"></slot>
        </div>
      </vue-perfect-scrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    name: {
      type: String,
      default: 'qb-sidebar',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Title',
    },
    size: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: 'white',
    },
    textColor: {
      type: String,
      default: '#626262',
    },
    sidebarClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
      },
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
  },
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
  },
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        if (this.$store.state.popup === false) {
          this.close()
        }
      }
    })
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#loading-${this.name}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-${this.name} > .con-vs-loading`)
      }
    },
    isSidebarActive(val) {
      if (val) {
        this.$emit('open')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.qb-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 30vw;
    max-width: 90vw;
  }
}

.sidebar-title {
  font-size: 18px;
}

@media (max-width: 600px) {
  .qb-sidebar.full {
    ::v-deep .vs-sidebar {
      width: 90vw;
    }
  }
}

.qb-sidebar.sm {
  ::v-deep .vs-sidebar {
    width: 50vw;
  }
}

.qb-sidebar.lg {
  ::v-deep .vs-sidebar {
    width: 70vw;
  }
}

.qb-sidebar.full {
  ::v-deep .vs-sidebar {
    width: 90vw;
  }
}

@media (max-width: 600px) {
  .qb-sidebar {
    ::v-deep .vs-sidebar {
      width: 90vw !important;
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  //height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  height: 90vh;

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
